import { useLoaderData } from 'react-router-dom';
import { Container } from '@dma/ui';
import type { MineralDto } from '../application/dto/MineralDto';
import { useDocumentHead } from '../../../app/seo/useDocumentHead';
import './MineralDetailPage.css';

export function MineralDetailPage() {
  const mineral = useLoaderData() as MineralDto;
  useDocumentHead(mineral.seo);
  const galleryImages = mineral.images.slice(1);

  return (
    <Container>
      <article className="dma-mineral-detail">
        <img
          className="dma-mineral-detail__image"
          src={mineral.images[0]}
          alt={mineral.name}
          loading="lazy"
        />
        <h1>{mineral.name}</h1>
        <p className="dma-mineral-detail__description">{mineral.description}</p>

        {mineral.specifications.length > 0 ? (
          <div className="dma-mineral-detail__section">
            <h2>مشخصات فنی</h2>
            <dl className="dma-mineral-detail__specs">
              {mineral.specifications.map((spec) => (
                <div key={spec.label}>
                  <dt>{spec.label}</dt>
                  <dd>{spec.value}</dd>
                </div>
              ))}
            </dl>
          </div>
        ) : null}

        {mineral.applications.length > 0 ? (
          <div className="dma-mineral-detail__section">
            <h2>کاربردها</h2>
            <ul>
              {mineral.applications.map((application) => (
                <li key={application}>{application}</li>
              ))}
            </ul>
          </div>
        ) : null}

        {galleryImages.length > 0 ? (
          <div className="dma-mineral-detail__section">
            <h2>تصاویر بیشتر</h2>
            <div className="dma-mineral-detail__gallery">
              {galleryImages.map((image) => (
                <img key={image} src={image} alt={mineral.name} loading="lazy" />
              ))}
            </div>
          </div>
        ) : null}
      </article>
    </Container>
  );
}
